import { PhoneOff } from 'lucide-react';
import type { MouseEvent } from 'react';
import { Button } from '@/components/ui/button';
import type { LiveCall } from '../types';
import { hangupChannelId } from '../liveCallsModel';

interface Props {
  call: LiveCall;
  /** The host owns the confirm dialog; this button only reports the click. */
  onHangup: (call: LiveCall) => void;
  variant?: 'icon' | 'full';
}

export default function HangupButton({ call, onHangup, variant = 'icon' }: Props) {
  if (!hangupChannelId(call)) return null;

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation(); // the row click opens the detail sheet
    onHangup(call);
  };

  if (variant === 'full') {
    return (
      <Button type="button" variant="destructive" size="sm" className="w-full" onClick={handleClick}>
        <PhoneOff className="h-4 w-4" />
        Hang up call
      </Button>
    );
  }
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-7 w-7 text-destructive hover:bg-destructive/10 hover:text-destructive"
      title="Hang up this call"
      aria-label="Hang up this call"
      onClick={handleClick}
    >
      <PhoneOff className="h-4 w-4" />
    </Button>
  );
}
